import React from 'react';
import { Icon } from './Icon.js';
export const IconShapeLine = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M3.5 20.5L20.5 3.5", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconShapeLine.js.map